import { Modal } from "antd";
import { MenuFolderDto } from "../../generated/dashboard-client";
import "./MoveToFolderModal.scss";
import { FolderThumb } from "../pages/Designs";
import { MoveToFolderMenuContent } from "./MoveToFolderMenuContent";

export interface MoveToFolderModalProps {
  isVisible: boolean;
  ids: string[];
  folders: MenuFolderDto[];
  activeFolder: MenuFolderDto | null;
  onCloseMovedToFolder: (save: boolean, folder?: MenuFolderDto) => void;
  onCloseMovedToSavedDesigns: (designIds: string[]) => void;
  onCloseMovedFolderToFolder: (childFolderId: number, parentFolderId: string) => void;
  onCreateNewFolder: () => void;
  folderToMove: MenuFolderDto | null;
  folderThumbs: FolderThumb[];
  folderNameExists: (folder: MenuFolderDto | null, name: string) => boolean | undefined;
  onCreateFolderModalClose: (ids: string[], folderToMove?: MenuFolderDto | null, folder?: MenuFolderDto) => void;
}

export function MoveToFolderModal({
  isVisible,
  ids,
  folders,
  activeFolder,
  onCloseMovedToFolder,
  onCloseMovedToSavedDesigns,
  onCloseMovedFolderToFolder,
  onCreateNewFolder,
  onCreateFolderModalClose,
  folderToMove,
  folderThumbs,
  folderNameExists
}: MoveToFolderModalProps) {
  return (
    <Modal
      className={"clean one add-design-to-folder"}
      visible={isVisible}
      onCancel={() => onCloseMovedToFolder(false)}
    >
      <MoveToFolderMenuContent
        ids={ids}
        folders={folders}
        activeFolder={activeFolder}
        onCloseMovedToFolder={onCloseMovedToFolder}
        onCloseMovedToSavedDesigns={onCloseMovedToSavedDesigns}
        onCloseMovedFolderToFolder={onCloseMovedFolderToFolder}
        folderToMove={folderToMove}
        folderThumbs={folderThumbs}
        folderNameExists={folderNameExists}
        onCreateFolderModalClose={onCreateFolderModalClose}
        onBack={() => { return }}
        isMobile={false}
      />
    </Modal>
  );
}
